import React, { useEffect, useRef } from 'react';

import { SearchBar } from 'apps/auth/components/form/components/SearchBar/SearchBar';
import { timer } from 'apps/auth/helpers/utils';
import { useExtra } from 'apps/auth/hooks/selectors';
import { CountrySearchService } from 'apps/auth/services/countrySearchService';

export const CountrySearchBar = (props) => {
    const { searchCountryName } = useExtra();
    const timerID = useRef(null);
    const searchRef = useRef(null);

    useEffect(() => {
        if (searchCountryName) {
            search(searchCountryName);
            searchRef.current.value = searchCountryName;
        }
        return () => {
            clearTimeout(timerID.current);
        };
    }, []);

    const search = (value) => {
        const term = value;
        const resultList = CountrySearchService.search(props.countries, value);

        props.setCountryList({
            countryList: resultList,
            hideLetter: !!term,
            query: term,
        });
    };

    const debouncedSearch = (value) => (timerID.current = timer(timerID.current, () => search(value)));

    return (
        <SearchBar
            searchRef={searchRef}
            placeholder={props.placeholder}
            onChange={(e) => debouncedSearch(e.target.value)}
            onCloseButtonClick={(e) => props.toggleSearch(e, false)}
        />
    );
};
